<template>
  <div class="rounded-[30px] bg-white p-4 pb-8 text-[#3C3C3C]">
    <AppDataProperty
      contentId="appInfo"
      @dataAvailable="
        data => {
          appInfo = data?.metaData || {}
        }
      "
    />
    <AppDataProperty
      contentId="subscription"
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
    />
    <div class="dropShadowXs">
      <div class="flex gap-4 items-center justify-between">
        <div class="flex gap-4 items-center">
          <div class="w-20 h-20 rounded-full p-4 bg-slate-100">
            <img
              src="@/assets/images/king-recharge-assets/crown-blue.svg"
              alt=""
              class="w-full h-full"
            />
          </div>
          <div>
            <div class="font-bold text-[#141922]">
              {{ $t('coupons.vipSection.bestOffer') }}
            </div>
            <div>
              {{ $t('coupons.vipSection.vipKing') }}
            </div>
          </div>
        </div>
        <!-- <div class="w-20 h-20 bodyBg rounded-full"></div> -->
      </div>
      <div class="px-2">
        <div class="py-2"></div>
        <div class="flex justify-between items-end">
          <div>
            <div class="underline">
              {{ $t('coupons.vipSection.recommendedOffer') }}
            </div>
            <!-- <div class="py-3"></div> -->
            <div class="text-6xl title-color inline-block relative">
              <div
                class="w-16 right-0 absolute translate-x-2/3 -translate-y-3/4"
              >
                <img
                  src="@/assets/images/king-recharge-assets/crown-blue.svg"
                  class="w-full"
                  alt=""
                />
              </div>
              <div class="font-bold text-[#42ceff]">
                {{ $t('coupons.vipSection.vipKing') }}
              </div>
            </div>
            <div class="py-2"></div>
            <div
              class="font-bold text-[#141922] text-2xl"
              v-if="!this.subscription?.isActive"
            >
              {{ $t('coupons.vipSection.increaseChance') }}
            </div>
            <div class="font-bold text-[#141922] text-2xl" v-else>
              {{ $t('coupons.vipSection.subscribedToVip') }}
            </div>
            <div class="py-2"></div>

            <div
              class="flex flex-col gap-2 text-lg"
              v-if="!this.subscription?.isActive"
            >
              <div class="flex items-center gap-2">
                <div class="w-5 h-5">
                  <img src="@/assets/images/all/check.svg" alt="" />
                </div>
                <div>
                  <span class="font-bold text-[#141922]">
                    {{ $t('coupons.vipSection.nbWiningCoupns') }}
                  </span>
                  <span>
                    {{ $t('coupons.vipSection.winingCoupns') }}
                  </span>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-5 h-5">
                  <img src="@/assets/images/all/check.svg" alt="" />
                </div>
                <div>
                  <span
                    v-html="$t('coupons.vipSection.kingVipValidity')"
                  ></span>
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-2 text-lg" v-else>
              <div class="flex items-center gap-2">
                <div class="w-5 h-5">
                  <img src="@/assets/images/all/check.svg" alt="" />
                </div>
                <div>
                  <!-- <span class=" text-[#141922]">
                        Valable jusqu'au 18 Nov 2024
                      </span> -->
                </div>
              </div>
            </div>
            <div class="py-2"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="w-28 h-28 relative">
              <div
                class="w-full h-full absolute skew-y-[-9deg] rotate-[0.5deg]"
              >
                <div
                  class="text-white text-4xl font-bold w-full text-center"
                  style="text-stroke: 1px #181a21"
                >
                  {{ vipSubscriptionAmount }}
                </div>
                <div
                  class="text-[#42ceff] text-3xl font-bold w-full text-center -mt-[0.5rem]"
                >
                  FCFA
                </div>
                <div
                  class="absolute bottom-2 text-[#181A21] text-lg font-bold w-full text-end mt-[0.5rem] pr-3"
                >
                  {{ $t('coupons.vipSection.vipKingDuration') }}
                </div>
              </div>
              <img src="@/assets/images/all/vipPrice.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="flex justify-center" v-if="!this.subscription?.isActive">
          <button
            class="font-bold buttonComponent small text-xl"
            @click="subscribeToVip"
          >
            {{ $t('coupons.vipSection.subscribe') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../AppDataProperty.vue'

export default defineComponent({
  name: 'VipPresentation',
  components: { AppDataProperty },
  props: {},
  data() {
    return {
      appInfo: {},
      subscription: {},
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    subscribeToVip() {
      this.$Events.dispatchEvent('vip_subscription_requested')
    },
  },
  computed: {
    vipSubscriptionAmount() {
      return this.appInfo?.vipSubscriptionAmount || 1200
    },
  },
})
</script>
